import axios from "axios";
import { Modal } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BsCheckCircle } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { ReactComponent as CloseIcon } from "../../../Assets/Global/close.svg";
import { options } from "../../../Utils/constants";
import { cleaner, getLocalStorage } from "../../../Utils/localStorage";

import "../../../Components/RegisterModal/RegisterModal.scss";

const TiersModal = ({ show, toggleModal }) => {
  const nav = useNavigate();

  const sendData = async () => {
    let platforms = [];

    if (getLocalStorage("tier3") !== null) {
      if (getLocalStorage("t3")?.platforms1 && getLocalStorage("t3")?.platforms1?.years !== null) {
        platforms.push(getLocalStorage("t3").platforms1);
      }
      if (getLocalStorage("t3")?.platforms2 && getLocalStorage("t3")?.platforms2?.years !== null) {
        platforms.push(getLocalStorage("t3").platforms2);
      }
      if (getLocalStorage("t3")?.platforms3 && getLocalStorage("t3")?.platforms3?.years !== null) {
        platforms.push(getLocalStorage("t3").platforms3);
      }
    }

    let obj = {
      country: getLocalStorage("t1") !== null ? getLocalStorage("t1").country : undefined,
      joining_reason:
        getLocalStorage("t1") !== null ? getLocalStorage("t1").joining_reason : undefined,
      age: getLocalStorage("t2") !== null ? getLocalStorage("t2").age : undefined,
      languages: getLocalStorage("t2") !== null ? getLocalStorage("t2").languages : undefined,
      interests: getLocalStorage("t2") !== null ? getLocalStorage("t2").interests : undefined,
      highest_education:
        getLocalStorage("t2") !== null ? getLocalStorage("t2").academic : undefined,
      job_status: getLocalStorage("t2") !== null ? getLocalStorage("t2").jobStatus : undefined,
      social_media_reach:
        getLocalStorage("t2") !== null ? +getLocalStorage("t2").socialMediaReach : undefined,
      socials: getLocalStorage("t2") !== null ? getLocalStorage("t2").socialMedia : undefined,
      sales_experience_years:
        getLocalStorage("t3") !== null ? +getLocalStorage("t3").sales_experience_years : undefined,
      sales_experience_volumes:
        getLocalStorage("t3") !== null
          ? +getLocalStorage("t3").sales_experience_volumes
          : undefined,
      expectations: getLocalStorage("t3") !== null ? getLocalStorage("t3").expectations : undefined,
      full_name: getLocalStorage("t1") !== null ? getLocalStorage("t1").full_name : undefined,
      phone: getLocalStorage("t1") !== null ? getLocalStorage("t1").phone : undefined,
      about: getLocalStorage("t2") !== null ? getLocalStorage("t2").about : undefined,
      sales_experience_description:
        getLocalStorage("t3") !== null
          ? getLocalStorage("t3").sales_experience_description
          : undefined,
      sales_experience_platforms: platforms.length ? platforms : undefined
    };

    const response = await axios
      .post(`${process.env.REACT_APP_EDAIN_URL}/api/v1/bazaar/partner/private/profile`, obj, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`
        }
      })
      .catch((error) => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              toast.error("Please log in again", { toastId: "error-401" });
              localStorage.removeItem("jwt");
              break;
            case 403:
              toast.error("Something went wrong, your application is already pending.", {
                toastId: "error-403",
                hideProgressBar: true,
                style: options.dropdownStyle
              });
              setTimeout(() => {
                nav("/status");
              }, 3000);
              break;
            case 422:
              toast.error("Validation failed. Please complete all the required fields.", {
                toastId: "error-422",
                hideProgressBar: true,
                style: options.dropdownStyle
              });
              break;
          }
        }
      });
    if (response?.status === 200) {
      cleaner();
      nav("/status");
    }
  };
  return (
    <Modal
      show={show}
      onHide={toggleModal}
      centered
      className="register-modal join-modal"
      id="register-modal">
      <Modal.Header>
        <div className="w-100 d-flex align-items-center justify-content-between">
          <h4 className="text-start font-size-32 font-pnb color-white">Send your application</h4>
          <CloseIcon onClick={toggleModal} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <p className="font-size-18 fw-normal font-pnb text-light">
          In order for your application to be approved, you must be selected by an existing user and
          assigned to their team. The more details you include, the better your chances to be
          quickly selected in order to register in the platform.
        </p>
        <hr style={{ borderColor: "#fff", margin: "20px 0" }} />
        <p className="font-size-18 font-pnb text-light">Completed sections:</p>

        <div className="d-flex gap-3 align-items-center mb-3">
          {getLocalStorage("tier1") !== null ? (
            <BsCheckCircle fontSize={20} color="#3cb043" />
          ) : (
            <AiOutlineCloseCircle fontSize={23} color="#ff2e2e" />
          )}

          <span className="font-pnb font-size-18 text-light">Contact information</span>
        </div>

        <div className="d-flex gap-3 align-items-center mb-3">
          {getLocalStorage("tier2") !== null ? (
            <BsCheckCircle fontSize={20} color="#3cb043" />
          ) : (
            <AiOutlineCloseCircle fontSize={23} color="#ff2e2e" />
          )}

          <span className="font-pnb font-size-18 text-light">About you</span>
        </div>

        <div className="d-flex gap-3 align-items-center mb-3">
          {getLocalStorage("tier3") !== null ? (
            <BsCheckCircle fontSize={20} color="#3cb043" />
          ) : (
            <AiOutlineCloseCircle fontSize={23} color="#ff2e2e" />
          )}

          <span className="font-pnb font-size-18 text-light">Experience</span>
        </div>

        <hr style={{ borderColor: "#fff", margin: "20px 0" }} />
        <p className="mb-0 text-light font-pnb fw-normal font-size-14 d-flex">
          <AiOutlineInfoCircle color="#FFE13F" fontSize="20px" className="me-2" />
          <span>
            Please make sure all the data you have entered is correct. Once you have submitted your
            application, you can no longer make changes to it.
          </span>
        </p>

        <div className="text-end mt-4">
          <button className="gradient fill large-width" onClick={sendData}>
            <span>Send application</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default TiersModal;
